import React, { useState } from "react"
// import Select from '@atlaskit/select'

import { usePet } from '../../modules'

import Modal from "../reusable/modal"

const Forward = ({ visible, toggle, item, source, destination: dest = 'Doctor' }) => {
    const [desc, setDesc] = useState()
    const [destination, setDestination] = useState({ label: dest, value: dest })

    const onComplete = ({ data }, notif, ops) => {
        // onPerform(data)
        notif('Patient has been forwarded', ops('success'))
        
        setTimeout(toggle, 300)
    }

    // let destinations = ['Doctor']

    const [{ loading }, execute] = usePet('forwardPatient', {
        source,
        desc,
        destination: destination.value,
        id: item
    }, { notify: true, callback: onComplete, manual: true })
    
    return (
        <Modal
            w={ 400 }
            title="Forward Patient"
            toggle={toggle}
            visible={visible}>     
            {/* <div className="w-full md:w-1/2 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Destination
                </label>
                <Select
                    inputId="single-select-example"
                    className="single-select"
                    classNamePrefix="react-select"
                    onChange={ setDestination }
                    value={ destination }
                    options={ destinations.map(cat => ({ label: cat, value: cat })) }
                    placeholder="Choose Destination" />
            </div>   */}
            <div className="flex flex-wrap mt-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Reason for Forward
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-desc"
                        rows="4"
                        value={ desc }
                        onChange={ e => setDesc(e.target.value) }
                        placeholder="Description" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } className="text-white hisani-btn-orange font-medium rounded-lg text-sm mr-2 px-5 py-2.5 text-center">Forward Patient</button>
                <button onClick={ toggle } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}   

export default Forward